module.exports = __webpack_public_path__ + "static/media/absolute-inactive.8c050406.svg";